import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import {
  filterWithRelationsAndJson,
  type RelationalOrJsonEntityFilter,
} from "@shared/helpers/sql-relations";
import { CallCenterVolunteerGroup } from "./entity";

const createCustomFilter = createCustomFilterForEntity<CallCenterVolunteerGroup>();

export class CallCenterVolunteerGroupFilters {
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<CallCenterVolunteerGroup>
  >((filters) => {
    return filterWithRelationsAndJson(CallCenterVolunteerGroup)(filters);
  });
}
